var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-content"},[_vm._l((_vm.sections),function(s,i){return [_c('post-content-section',{attrs:{"section":s,"index":i}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }